export default "/images/e50320119a69d213da995dbed78147be.avif";